var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{class:_vm.selectClass,attrs:{"id":_vm.id,"options":_vm.options,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"value":_vm.value,"reduce":(category) => category.value},on:{"input":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }